module.exports = __webpack_public_path__ + "media/application/images/icons/france-49da7d5ef9f87999f10de82b23315772.svg";